"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var SvgAmenityTailgating = function SvgAmenityTailgating(_ref) {
  var svgRef = _ref.svgRef,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef"]);
  props.className = (0, _classnames.default)('Icon', props.className);
  return _react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    ref: svgRef
  }, props), _react.default.createElement("path", {
    d: "M823.4 767.2C752.8 767.2 695 825 695 895.6S752.8 1024 823.4 1024s128.4-57.8 128.4-128.4S894 767.2 823.4 767.2zm0 192.6c-35.3 0-64.2-28.9-64.2-64.2s28.9-64.2 64.2-64.2 64.2 28.9 64.2 64.2-28.9 64.2-64.2 64.2zM611.5 680.5c41.7 0 64.2 3.2 96.3 61 6.4 9.6 9.6 19.3 16.1 28.9 25.7-12.8 44.9-25.7 67.4-38.5-12.8-28.9-22.5-51.4-35.3-80.3C865.1 597 919.7 513.6 929.3 398c0-6.4 9.6-12.8 12.8-19.3 6.4-12.8 12.8-22.5 19.3-35.3-16.1-6.4-28.9-19.3-44.9-19.3-61-3.2-122-3.2-179.8-3.2h-6.4c12.8-35.3 41.7-70.6 61-102.7C833 154.1 820.2 122 756 70.6c19.3 61 0 105.9-38.5 150.9-32.2 38.5-38.6 70.6-22.5 99.5H582.6c-6.4-51.4 25.7-99.5 64.2-144.5 16.1-19.3 32.1-38.5 38.5-61C704.6 73.8 695 35.3 650 0c12.8 67.4-28.9 125.2-73.8 183-32.1 44.9-35.3 89.9-3.2 134.8H415.7C435 279.3 473.5 237.5 496 199c35.3-57.8 9.6-96.3-48.2-138 28.9 64.2 0 105.9-35.3 150.9-35.3 44.9-35.3 77-16.1 105.9H261.6c-12.8 0-28.9 9.6-35.3 19.3-3.2 3.2-12.8 22.5-6.4 32.1 6.4 12.8 12.8 25.7 28.9 51.4H62.6v54.6c16.1 3.2 32.1 9.6 48.2 9.6h122c12.8 0 35.3 6.4 38.5 16.1 32.1 80.3 93.1 102.7 166.9 147.7-51.4 102.7-131.6 234.3-176.6 337.1L329 1024c25.7-70.6 67.4-70.6 99.5-70.6 80.3 3.2 157.3 0 240.8 0-3.2-28.9-3.2-54.6-6.4-80.3H422.1c16.1-32.1 28.9-57.8 38.5-83.5 28.9-64.1 48.2-112.3 150.9-109.1zM402.9 526.4c-3.2 3.2-22.5 3.2-22.5 0-19.3-38.5-38.5-77-57.8-115.6-3.2-3.2 35.3-19.3 51.4-35.3 9.6 25.7 6.4 16.1 9.6 25.7 16.1 28.9 28.9 57.8 41.7 86.7 3.2 6.4-19.2 28.9-22.4 38.5z"
  }));
};

var ForwardRef = _react.default.forwardRef(function (props, ref) {
  return _react.default.createElement(SvgAmenityTailgating, (0, _extends2.default)({
    svgRef: ref
  }, props));
});

var _default = ForwardRef;
exports.default = _default;